export const CLASS_NAMES = {
  title: 'text-18-22-em text-neutral-900 mb-4 md:mb-6',
  checksTitle: 'text-14-22 text-neutral-700 mb-4',
  listTitle: 'text-14-22 text-neutral-700 mt-8 mb-4',
};

export const TITLE_PROPS = {
  text: 'Terms, Conditions & Agreement',
  className: CLASS_NAMES.title,
  skeletonProps: {
    width: 280,
  },
};

export const CHECKS_TITLE_PROPS = {
  text: 'Before proceeding, please be sure that you:',
  className: CLASS_NAMES.checksTitle,
  skeletonProps: {
    width: 280,
  },
};

export const CHECKS_PROPS = {
  items: [
    'Understand you are about to enter into a credit agreement, and that interest may be payable depending on the credit agreement you have chosen',
    'Can afford to pay the deposit if you have chosen to do so',
    'Understand the credit checks will be undertaken as part of the application process, which may leave a footprint on your credit history',
    'Have salary and bank details at hand',
  ],
};

export const LIST_TITLE_PROPS = {
  text: 'Please confirm that:',
  className: CLASS_NAMES.listTitle,
  skeletonProps: {
    width: 100,
  },
};

export const HUMM_LIST_PROPS = {
  className: 'mb-6 md:mb-10',
  items: [
    <p key="item-1">
      You are 18 or over, and a permanent UK resident able to supply UK address
      history for the last 3 years.
    </p>,
    <p key="item-2">
      You have a gross annual income each year of more than £10,000 and a bank
      or building society account with Direct Debit facility.
    </p>,
    <p key="item-3">
      You are not currently bankrupt, subject to an Individual Voluntary
      Agreement (IVA), or have any County Court Judgements (CCJs).
    </p>,
    <p key="item-11">
      I agree that Humm may communicate with me and send important documents
      (including documents under the Consumer Credit Act 1974) by email at the
      address I have provided, and the email may provide the document in the
      form of an attachment or a link to the document.
    </p>,
    <p key="item-4">
      I understand that the information I am about to supply will be retained on
      an electronic database and used in the course of considering my credit
      application and the management of any subsequent accounts, that you may
      also make checks to confirm my income or employment and that you may share
      personal data with selected third parties as part of the application
      process.
    </p>,
    <p key="item-5">
      I confirm that the information I have supplied in support of this credit
      application is true, and that I am not aware of any potential changes to
      my financial circumstances both at present and for the duration of the
      borrowing term.
    </p>,
    <p key="item-6">
      I understand that before I sign the loan agreement I will be provided with
      documentation that will outline the amount I am borrowing, the interest
      rate that will be charged and my monthly repayments. I understand that it
      is important for me to consider the above in line with my personal
      circumstances.
    </p>,
    <p key="item-7">
      I understand that upon completion of the credit application form, a search
      will be conducted with one or more Credit Reference Agencies (CRA) of my
      credit file and that this includes the use of both public data and shared
      data. This will show as a hard credit check on your records at the CRAs,
      and this credit check will be visible to other providers of credit/other
      lenders/other organisations should they perform checks
    </p>,
    <p key="item-8">
      I understand that the personal information we have collected from you will
      be shared, via Humm, with fraud prevention agencies to prevent fraud and
      money laundering and to verify your identity. If fraud is detected, you
      could be refused certain services, finance, or employment. Further details
      of how your information will be used by us and these fraud prevention
      agencies, and your data protection rights, can be found by reviewing
      Ideal4Finance&apos;s{' '}
      <a
        rel="noreferrer"
        target="_blank"
        href="https://ideal4finance.com/privacy"
        className="underline text-purple-500"
      >
        Privacy Policy
      </a>{' '}
      as well as Humm&apos;s{' '}
      <a
        rel="noreferrer"
        target="_blank"
        href="https://ideal4finance.com/privacy"
        className="underline text-purple-500"
      >
        Privacy Policy
      </a>
      .
    </p>,
    <p key="item-9">
      You accept that if you apply for and are successful in obtaining Financing
      the maximum warranty period in relation to installation is two years,
      regardless of any longer warranty period that is stated in the Quote or
      communicated to you by the Tradesperson. This is a condition of the
      Financing and the Company disclaims any liability in relation to
      installation after the expiry of the two-year warranty period. For the
      avoidance of doubt, this does not apply to any warranty period in relation
      to products.
    </p>,
  ],
};

export const LIST_PROPS = {
  className: 'mb-6 md:mb-10',
  items: [
    <p key="item-1">
      You are 18 or over, and a permanent UK resident able to supply UK address
      history for the last 3 years.
    </p>,
    <p key="item-2">
      You have a gross annual income each year of more than £10,000 and a bank
      or building society account with Direct Debit facility.
    </p>,
    <p key="item-3">
      You are not currently bankrupt, subject to an Individual Voluntary
      Agreement (IVA), or have any County Court Judgements (CCJs).
    </p>,
    <p key="item-4">
      I understand that the information I am about to supply will be retained on
      an electronic database and used in the course of considering my credit
      application and the management of any subsequent accounts, that you may
      also make checks to confirm my income or employment and that you may share
      personal data with selected third parties as part of the application
      process.
    </p>,
    <p key="item-5">
      I confirm that the information I have supplied in support of this credit
      application is true, and that I am not aware of any potential changes to
      my financial circumstances both at present and for the duration of the
      borrowing term.
    </p>,
    <p key="item-6">
      I understand that before I sign the loan agreement I will be provided with
      documentation that will outline the amount I am borrowing, the interest
      rate that will be charged and my monthly repayments. I understand that it
      is important for me to consider the above in line with my personal
      circumstances.
    </p>,
    <p key="item-7">
      I understand that upon completion of the credit application form, a search
      will be conducted with one or more Credit Reference Agencies (CRA) of my
      credit file and that this includes the use of both public data and shared
      data. This will show as a hard credit check on your records at the CRAs,
      and this credit check will be visible to other providers of credit/other
      lenders/other organisations should they perform checks
    </p>,
    <p key="item-8">
      I understand that the personal information we have collected from you will
      be shared, via $LENDER, with fraud prevention agencies to prevent fraud
      and money laundering and to verify your identity. If fraud is detected,
      you could be refused certain services, finance, or employment. Further
      details of how your information will be used by us and these fraud
      prevention agencies, and your data protection rights, can be found by
      reviewing Ideal4Finance&apos;s{' '}
      <a
        rel="noreferrer"
        target="_blank"
        href="https://ideal4finance.com/privacy"
        className="underline text-purple-500"
      >
        Privacy Policy
      </a>
    </p>,
    <p key="item-9">
      You accept that if you apply for and are successful in obtaining Financing
      the maximum warranty period in relation to installation is two years,
      regardless of any longer warranty period that is stated in the Quote or
      communicated to you by the Tradesperson. This is a condition of the
      Financing and the Company disclaims any liability in relation to
      installation after the expiry of the two-year warranty period. For the
      avoidance of doubt, this does not apply to any warranty period in relation
      to products.
    </p>,
  ],
};
